import { HTMLAttributes } from 'react';

export function TableRole(props: HTMLAttributes<HTMLDivElement>) {
	return <div {...props} role="table" />;
}

export function RowRole(props: HTMLAttributes<HTMLDivElement>) {
	return <div {...props} role="row" />;
}

export function CellRole(props: HTMLAttributes<HTMLDivElement>) {
	return <div {...props} role="cell" />;
}
